var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.58 22.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.29,0C5.05,0,0,5.05,0,11.29s5.05,11.29,11.29,11.29,11.29-5.05,11.29-11.29S17.52,0,11.29,0Zm0,17.17c-.65,0-1.18-.53-1.18-1.18s.53-1.18,1.18-1.18,1.18,.53,1.18,1.18-.53,1.18-1.18,1.18Zm1.84-5.58c-.85,.92-.89,1.42-.88,2.05h-1.89c0-1.39,.02-2,1.35-3.26,.54-.51,.96-.92,.9-1.71-.05-.76-.69-1.15-1.28-1.15-.67,0-1.45,.5-1.45,1.89h-1.89c0-2.26,1.33-3.72,3.38-3.72,.97,0,1.83,.32,2.4,.9,.54,.54,.81,1.29,.8,2.16-.02,1.3-.81,2.16-1.44,2.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.31eaa9e3866d85958415b78435a2bb37.svg";
export { ForwardRef as ReactComponent };